module.exports = __webpack_public_path__ + "static/media/square-down-right.65366346.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/square-down-right.svg
// module id = 3556
// module chunks = 7